<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="true"/>
        <div class="mypage_mainwindow">
            <div class="pageTitles">
                <div class="icon-icon-mypage mypage-title-icon"></div>
                マイページトップ
                <button @click="openHelpPage" class="btn btn-outline-info help-btn">ヘルプ</button></div>
            <div class="cardwindow mb-3">
                <div class="row mb-3">
                    <div class="col myNumber">
                        <div class="accentBox">
                            <div class="Mypagetop_accentBox__headings">会員番号</div>
                            <div class="accentBox__content">{{ from_set_data.member_no }}</div>
                        </div>
                    </div>
                    <div class="col-4 myLine pcview mr-2">
                        <div class="lineBtn" v-if="line_status">
                            <div class="lineBtn__inner">
                                LINEアカウント連携済
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row ml-2">
                    <h5 class="col font-weight-bold">{{ from_set_data.full_name }}&nbsp;&nbsp;様</h5>
                </div>
                <div class="row ml-2" v-if="message_info !== false">
                    <small class="col message-text">{{ message_info }}</small>
                </div>
                <div class="row row-notMx mb-3">
                    <div class="col myLine splineview">
                        <div class="lineBtn" v-if="line_status">
                            <div class="lineBtn__inner">
                                LINEアカウント連携済
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12">
                        <div class="mypagecard graywindow" v-if="member_rank">
                            <div>
                                <div class="row justify-content-start m-3">
                                    <div class="col-sm-5" v-if="select_point_use">
                                        <select
                                            class="form-control"
                                            v-model="get_golf_code"
                                            @change="ChangeGolfCode"
                                        >
                                            <option
                                                v-for="data in get_point_use_type"
                                                :key="data.golf_code"
                                                :value="data.golf_code"
                                            >
                                                {{ data.golf_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="my-3 messageBox row row-notMx justify-content-around">
                                    <div class="col-sm-3 align-self-center">
                                        <div class="circle-container">
                                            <div class="mypage-circle-content">保有ポイント合計</div>
                                            <div class="mypage-point-circle">{{ this.total_points }}pt</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div>
                                            <div class="my-2">
                                                <div class="row row-notMx justify-content-between">
                                                    <div>通常ポイント</div>
                                                    <div class="font-weight-bold">{{ this.total_normal }}pt</div>
                                                </div>
                                                <div class="row row-notMx">
                                                    <small v-if="this.min_valid_date_limited_normal">（最短有効期限：{{ this.min_valid_date_limited_normal | date_format_ja('-') }}）</small>
                                                </div>
                                                <div class="mypage-gray-border-bottom pt-1"></div>
                                            </div>
                                            <div class="my-2">
                                                <div class="row row-notMx justify-content-between">
                                                    <div>期間限定ポイント</div>
                                                    <div class="font-weight-bold">{{ this.total_limited }}pt</div>
                                                </div>
                                                <div class="row row-notMx">
                                                    <small v-if="this.min_valid_date_limited">（最短有効期限：{{ this.min_valid_date_limited | date_format_ja('-') }}）</small>
                                                </div>
                                                <div class="mypage-gray-border-bottom pt-1"></div>
                                            </div>
                                            <div class="my-2">
                                                <div class="row row-notMx justify-content-between">
                                                    <div>利用予定ポイント</div>
                                                    <div class="font-weight-bold">{{ this.total_reserve }}pt</div>
                                                </div>
                                                <div class="row row-notMx">
                                                    <small v-if="this.play_date">（直近利用予定：{{ this.play_date | date_format_ja('-') }}）</small>
                                                </div>
                                                <div class="mypage-gray-border-bottom pt-1"></div>
                                            </div>
                                            <div class="mb-4 mt-2">
                                                <div class="row row-notMx justify-content-between">
                                                    <div>獲得予定ポイント</div>
                                                    <div class="font-weight-bold">{{ this.total_expected }}pt</div>
                                                </div>
                                                <div class="row row-notMx">
                                                    <small v-if="this.expected_date">（直近獲得予定：{{ this.expected_date | date_format_ja('-') }}）</small>
                                                </div>
                                                <div class="mypage-gray-border-bottom pt-1 mb-2"></div>
                                            </div>  
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                class="btn btn-outline-info btn-md btn-block"
                                                v-on:click="GotoPoint()"
                                            >ポイント履歴を見る</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="member_rank">
                                <div class="messageBox mypage-gray-border-top py-3 mypage-limit-table">
                                    <h5 class="font-weight-bold text-center mb-4">期間限定ポイント一覧</h5>
                                    <div class="row row-notMx justify-content-around mb-4">
                                        <div v-for="data in get_limited_point" :key="data.id" class="col-sm-3 col-notMx table-line limit-table-flex">
                                            <div class="mypage-black-border"></div>
                                            <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                <div class="col-4 col-notMx">有効期限</div>
                                                <div class="col-8 col-notMx font-weight-bold text-right">{{ data.valid_date | date_format_ja('-') }}</div>
                                            </div>
                                            <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                <div class="col-4 col-notMx">内容</div>
                                                <div class="col-8 col-notMx font-weight-bold text-right">{{ data.action }}</div>
                                            </div>
                                            <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                <div class="col-4 col-notMx">区分</div>
                                                <div class="col-8 col-notMx font-weight-bold text-right">{{ data.point_type_display }}</div>
                                            </div>
                                            <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                <div class="col-4 col-notMx">ポイント</div>
                                                <div class="col-8 col-notMx font-weight-bold text-right">{{ data.point }}</div>
                                            </div>
                                            <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                <div class="col-4 col-notMx">コメント</div>
                                                <div class="col-8 col-notMx font-weight-bold text-right">{{ data.comment }}</div>
                                            </div>
                                        </div>
                                        <template v-if="get_limited_point_disp_count === 1">
                                            <div class="col-sm-3 table-line d-sm-block d-none col-notMx limit-table-flex">
                                                <div class="mypage-black-border"></div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 table-line d-sm-block d-none col-notMx limit-table-flex">
                                                <div class="mypage-black-border"></div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- 表示が2の時のoffset -->
                                        <template v-if="get_limited_point_disp_count === 2">
                                            <div class="col-sm-3 table-line d-sm-block d-none col-notMx limit-table-flex">
                                                <div class="mypage-black-border"></div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                                <div class="row row-notMx justify-content-between mypage-gray-border-bottom">
                                                    <div class="col-4 col-notMx">&nbsp;</div>
                                                    <div class="col-8 col-notMx font-weight-bold text-right">&nbsp;</div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <nav aria-label="Page navigation">
                                    <ul class="pagination pagination-sm">
                                        <li class="page-item">
                                            <button
                                                :disabled="paginationDisabled"
                                                class="btn btn-outline-info"
                                                @click="ClickPagination('Limited', 'Previous')">
                                            &nbsp;&lt;前へ&nbsp;</button>
                                        </li>
                                        <li class="pagination-center">
                                            <span>{{ display_pagination }} / {{ max_pagination }}</span>
                                        </li>
                                        <li class="page-item">
                                            <button
                                                class="btn btn-outline-info"
                                                :disabled="paginationDisabled"
                                                @click="ClickPagination('Limited', 'Next')">
                                                &nbsp;次へ&gt;&nbsp;
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="barcode-container mb-3">
                <div class="footer_display_on spBarcode text-center row no-gutters">
                    <MyPageBarCode v-bind:golfGroupCode="golf_group_code" v-bind:memberNo="from_set_data.member_no"/>
                </div>
            </div>
            <div class="barcode-container mb-3">
                <div class="footer_display_on spBarcode text-center row no-gutters">
                    <MyPageQrCode v-bind:golfGroupCode="golf_group_code" v-bind:memberNo="from_set_data.member_no"/>
                </div>
            </div>
        </div>
        <MypageFooter
            @out-click="logOutBtn"
        />
    </div>
</template>

<script>
import MypageFooter from './MypageFooter';
import MypageSideMenu from './MypageSideMenu';
import MyPageQrCode from '../components/MyPage/MyPageQrCode';
import MyPageBarCode from '../components/MyPage/MyPageBarCode';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { GET_MEMBER_ID, GET_MEMBER_STATUS } from '../../constants/signin.js';
import { GET_POINT_USE_TYPE, GET_POINT_TOTAL, GET_POINT_LIMITED_LIST } from '../../constants/mypage_top';
import { mapGetters } from 'vuex';
import { GET_MEMBER_RANK } from '../../constants/mypage_side_menu';
import { memberStatusMixin } from './memberStatusMixin';
import { GET_MESSAGE_INFO } from '../../constants/contact';

export default {
    components: {
        MypageSideMenu,
        MypageFooter,
        MyPageQrCode,
        MyPageBarCode,
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            classBlack: 'text-body',
            classRed: 'text-danger',
            member_rank: false,
            member_no: '',
            use_golf_code: '',
            golf_group_code: process.env.MIX_GROUP_CODE,
            from_set_data: {
                // 会員番号
                member_no: '',
                // フルネーム
                full_name: '',
            },
            line_status: false,
            line_setting_link: {
                title: 'LINEアカウント連携',
                to: '/mypage-line-setting'
            },
            select_point_use: false,
            get_point_use_type: [],
            get_golf_code: '',
            total_points: 0,
            total_normal: 0,
            total_limited: 0,
            total_expected: 0,
            total_reserve: 0,
            // 表示中の期間期限ポイントページネーション数
            display_pagination: 1,
            // 取得した期間期限ポイントデータ格納
            get_limited_point: [],
            // 表示する期間期限ポイントデータ格納
            display_limited_point: [],
            // 期間期限ポイント最大ページネーション数
            max_pagination: 1,
            // 期間限定ポイント一覧のカウント数
            get_limited_point_disp_count: 0,
            display_begin_row: 0,
            display_limit_rows: 3,
            point_flag_normal: 1,
            point_flag_limited_normal: 2,
            point_flag_limited: 3,
            min_valid_date_limited_normal: '',
            min_valid_date_limited: '',
            expected_date: '',
            play_date: '',
            // メッセージ受信の連絡
            message_info: ''
        };
    },
    computed: {
        ...mapGetters('auth', [
            "loginMemberLineFlag"
        ]),
        paginationDisabled () {
            return this.max_pagination === 1 || this.max_pagination === 0;
        },
    },
    created () {
        this.$router.push('/mypage-reserve-list');
        // this.initialize();
    },
    watch: {
        display_pagination: function (now) {
            this.display_limited_point = [];
            const nextNum = now * this.display_limit_rows;
            for (var i = nextNum - this.display_limit_rows; i < nextNum; i++) {
                if (this.get_limited_point[i] !== undefined) {
                    this.display_limited_point.push(this.get_limited_point[i])
                }
            }
        },
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit("loading/setIsLoading", true);
            await this.GetLoginUserMemberStatus();
            if (this.loginMemberLineFlag) {
                this.line_status = true
                this.line_setting_link.title = 'LINEアカウント連携解除';
                this.line_setting_link.to = '/mypage-line-setting-quit';
            }
            this.from_set_data.member_no = this.$store.state.auth.loginMember.member_no;
            this.from_set_data.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            try {
                this.$apollo.query({
                    query: GET_POINT_USE_TYPE,
                    variables: {
                        golf_group_code: this.golf_group_code,
                        member_no: this.from_set_data.member_no
                    }
                }).then(res => {
                    if (res.data.getPointUseType !== null) {
                        this.select_point_use = true;
                        this.get_point_use_type = res.data.getPointUseType;
                        if (this.$store.state.mypage.useGolfCode !== null){
                            this.use_golf_code = this.$store.state.mypage.useGolfCode;
                        }else{
                            this.use_golf_code = this.get_point_use_type[0].golf_code;
                        }
                        this.get_golf_code = this.use_golf_code;
                        this.$store.commit('mypage/useGolfCode', this.get_golf_code);
                    } else {
                        this.select_point_use = false;
                    }
                })
                this.GetPointData();
                this.GetLimitedPointList(this.point_flag_limited);
            } catch(err) {
                console.log("エラーが起こりました:" + err);
            }
            this.GetMemberRank();
            this.GetMessegeInfo();
            this.$store.commit("loading/setIsLoading", false);
        },
        /** ----------------------------------------------
         * WEB会員の種別を取得
         * ---------------------------------------------- */
        GetMemberRank: function () {
            this.member_no = this.$store.state.auth.loginMember.member_no;

            this.$apollo.query({
                query: GET_MEMBER_RANK,
                variables: {
                    member_no: this.member_no
                }
            }).then(res => {
                if(res.data.getMemberRankByMemberId.member_rank == 1){
                    this.member_rank = true;
                }else{
                    this.member_rank = false;
                }
                return this.member_rank;
            })
        },
        /** ----------------------------------------------
         * ポイントがマイナス値の場合は赤字表示
         * ---------------------------------------------- */
        fontColor: function(data) {
            if (data.point < 0) {
                return this.classRed;
            } else {
                return this.classBlack;
            }
        },
        /** ----------------------------------------------
         * ポイントの合計値と履歴データの取得処理
         * ---------------------------------------------- */
        GetPointData: async function () {
            this.member_no = this.$store.state.auth.loginMember.member_no;
            await this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_POINT_TOTAL,
                variables: {
                    member_no: this.member_no,
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.get_golf_code,
                }
            }).then(res => {
                // ポイントの合計値取得
                if (!res.data.memberGetPointTotal.total_point.total_all) {
                    this.total_points = 0;
                    this.total_normal = 0;
                    this.total_limited = 0;
                    this.min_valid_date_limited_normal = '';
                    this.min_valid_date_limited = '';
                } else {
                    this.total_points = res.data.memberGetPointTotal.total_point.total_all;
                    this.total_normal = res.data.memberGetPointTotal.total_point.total_normal;
                    this.total_limited = res.data.memberGetPointTotal.total_point.total_limited;
                    this.min_valid_date_limited_normal = res.data.memberGetPointTotal.valid_date.total_limited_normal;
                    this.min_valid_date_limited = res.data.memberGetPointTotal.valid_date.total_limited;
                }
                if (!res.data.memberGetPointTotal.total_point.total_expected) {
                    this.total_expected = 0;
                    this.expected_date = '';
                } else {
                    this.total_expected = res.data.memberGetPointTotal.total_point.total_expected;
                    this.expected_date = res.data.memberGetPointTotal.valid_date.expected_date;
                }
                if (!res.data.memberGetPointTotal.total_point.total_reserve) {
                    this.total_reserve = 0;
                    this.play_date = '';
                } else {
                    this.total_reserve = res.data.memberGetPointTotal.total_point.total_reserve;
                    this.play_date = res.data.memberGetPointTotal.valid_date.play_date;
                }
            })
        },

        /** --------------------------------------------
         * 会員情報を取得
         * -------------------------------------------- */
        setMember: function (member_no) {
            this.from_set_data.member_no =this.$parent.member_no;
            this.from_set_data.full_name = this.$parent.family_name + ' ' + this.$parent.given_name;
        },
        ChangeGolfCode: async function () {
            this.total_points = '';
            this.display_limited_point = [];
            this.max_pagination = 1;
            this.display_pagination = 1;
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit('mypage/useGolfCode', this.get_golf_code);
            this.GetPointData();
            this.GetLimitedPointList();
            this.$store.commit("loading/setIsLoading", false);
        },
        ClickPagination: function (target, mode) {
            if (target === 'Limited') {
                // 前へボタン押下時処理
                if (mode === 'Previous') {
                    if (this.display_pagination > 1) {
                        this.display_pagination--;
                        if (this.display_pagination === 1) {
                            this.display_begin_row = 0;
                        } else {
                            this.display_begin_row = this.display_begin_row - this.display_limit_rows;
                        }
                        this.GetLimitedPointList();
                    } else {
                        return;
                    }
                } else {
                    // 次へボタン押下時処理
                    if (this.display_pagination < this.max_pagination) {
                        this.display_begin_row = this.display_begin_row + this.display_limit_rows;
                        this.display_pagination++;
                        this.GetLimitedPointList();
                    } else {
                        return;
                    }
                }
            }
        },
        GetLimitedPointList: function () {
            this.get_limited_point = [];
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_POINT_LIMITED_LIST,
                variables: {
                    member_no: this.from_set_data.member_no,
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: this.get_golf_code,
                    begin_row: this.display_begin_row,
                    limit_rows: this.display_limit_rows
                }
            }).then(res => {
                // 期間限定ポイントのデータ取得
                this.get_limited_point = res.data.getMemberLimitedPointList.MemberLimitedPointList;
                // 期間限定ポイントのデータ表示数
                this.get_limited_point_disp_count = res.data.getMemberLimitedPointList.MemberLimitedPointList.length;
                if (this.get_limited_point) {
                    // 期間期限ポイントの最大ページネーション数
                    if (res.data.getMemberLimitedPointList.count === 0) {
                        res.data.getMemberLimitedPointList.count = 1;
                    }
                    this.max_pagination = Math.ceil(res.data.getMemberLimitedPointList.count / this.display_limit_rows);
                }
            })
        },
        /** ----------------------------------------------
         * 最新メッセージの情報を取得
         * ---------------------------------------------- */
        GetMessegeInfo: function () {
            this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_MESSAGE_INFO,
                variables: {
                    member_no: this.from_set_data.member_no
                }
            }).then(res => {
                if (res.data.getMessageInfo.time.length > 0) {
                    if (res.data.getMessageInfo.reserve_no === "000000000000") {
                        this.message_info = "返信していないメッセージがあります。(受信日時：" + res.data.getMessageInfo.time + ")";
                    } else if (!res.data.getMessageInfo.play_date) {
                        this.message_info = false;
                    } else {
                        this.message_info = "返信していないメッセージがあります。(受信日時：" + res.data.getMessageInfo.time + "　プレー日：" + res.data.getMessageInfo.play_date + ")";
                    }
                } else {
                    this.message_info = false;
                }
                return this.message_info;
            }).catch(error => {
                this.message_info = false;
            });
        },
        GotoPoint: function () {
            // ポイント参照画面へ遷移
            this.$router.push({ path: '/mypage-point' });
        },
        logOutBtn () {
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$router.push('/');
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        openHelpPage() {
            window.open('/help', '_blank');
        }
    }
}

</script>

<style scoped>
</style>
